import GeneralLayout from '@/layouts/GeneralLayout.vue'

export default [
  {
    path: '/:locale(en|it|fr|de|es|pt|uk)',
    component: GeneralLayout,
    children: [
      {
        path: '',
        name: 'HomePage',
        component: () => import('@/views/general/HomePage.vue'),
        meta: { titleKey: 'seo.home.title', descriptionKey: 'seo.home.description' },
      },
      {
        path: 'manufacturers',
        name: 'ManufacturersPage',
        component: () => import('@/views/general/ManufacturersPage.vue'),
        meta: { titleKey: 'seo.manufacturers.title', descriptionKey: 'seo.manufacturers.description' },
      },
      {
        path: 'about',
        name: 'AboutUsPage',
        component: () => import('@/views/general/AboutUsPage.vue'),
        meta: { titleKey: 'seo.about.title', descriptionKey: 'seo.about.description' },
      },
      {
        path: 'blog',
        children: [
          {
            path: '',
            name: 'BlogPage',
            component: () => import('@/views/general/BlogPage.vue'),
            meta: { titleKey: 'seo.blog.title', descriptionKey: 'seo.blog.description' },
          },
          {
            path: ':slug',
            name: 'BlogItemPage',
            component: () => import('@/views/general/BlogShowPage.vue'),
            meta: { titleKey: 'seo.blog.title', descriptionKey: 'seo.blog.description' },
          },
        ],
      },
      {
        path: 'faq',
        name: 'FaqPage',
        component: () => import('@/views/general/FaqPage.vue'),
        meta: { titleKey: 'seo.faq.title', descriptionKey: 'seo.faq.description' },
      },
      {
        path: 'contact-us',
        name: 'ContactUsPage',
        component: () => import('@/views/general/ContactUsPage.vue'),
        meta: { titleKey: 'seo.contact.title', descriptionKey: 'seo.contact.description' },
      },
      {
        path: 'terms-and-conditions',
        name: 'TermsPage',
        component: () => import('@/views/general/legalDocuments/TermsPage.vue'),
        meta: { titleKey: 'seo.terms.title', descriptionKey: 'seo.terms.description' },
      },
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicyPage',
        component: () => import('@/views/general/legalDocuments/PrivacyPolicyPage.vue'),
        meta: { titleKey: 'seo.privacy.title', descriptionKey: 'seo.privacy.description' },
      },
      {
        path: 'cookie-policy',
        name: 'CookiePolicyPage',
        component: () => import('@/views/general/legalDocuments/CookiePolicyPage.vue'),
        meta: { titleKey: 'seo.cookie.title', descriptionKey: 'seo.cookie.description' },
      },
      {
        path: 'products',
        children: [
          {
            path: ':partNumber',
            name: 'ProductPage',
            component: () => import('@/views/general/ProductPage.vue'),
            meta: { title: 'Product — GMG Automation' },
          },
          {
            path: 'manufacturers/:manufacturerSlug',
            name: 'ManufacturerProductsPage',
            component: () => import('@/views/general/ManufacturerProductsPage.vue'),
            meta: { title: 'Products — GMG Automation' },
          },
        ],
      },
      {
        path: 'search/:partNumber?',
        name: 'SearchEnquiryPage',
        component: () => import('@/views/general/SearchEnquiryPage.vue'),
        meta: { title: 'Enquiry — GMG Automation', noindex: true },
      },
      {
        path: 'cart',
        name: 'CartPage',
        component: () => import('@/views/general/CartPage.vue'),
        meta: { title: 'Cart — GMG Automation', noindex: true },
      },
      {
        path: ':pathMatch(.*)*',
        name: 'GeneralNotFoundPage',
        component: () => import('@/views/status/NotFoundPage.vue'),
      },
    ],
  },
]
